var map = {
	"./icon1.png": 489,
	"./icon2.png": 410,
	"./icon3.png": 971,
	"./icon4.png": 572,
	"./icon5.png": 837,
	"./icon6.png": 6,
	"./icon7.png": 503,
	"./icon8.png": 144,
	"./icon9.png": 393
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 963;